export default __webpack_public_path__ + "static/media/MobileBackground.5c30e6ad.jpg";